module.exports = __webpack_public_path__ + "static/media/4641.d70fc30f.jpg";